import { styled } from '@linaria/react';

import { AgentSource } from '../../../api/events-client/events-client.type';
import { ProcessOverviewTile } from '../../process/process-overview';
import { agentSourcesIcon } from '../agentic-process-helpers';

type Props = {
  metadata: {
    uniqueSessions: number;
    mostUsedAgentSource: AgentSource;
    llmModels: string[];
    totalToolCalls: number;
    totalUserPrompts: number;
  };
};

export const AgenticProcessGraphOverview = ({ metadata }: Props) => {
  const { uniqueSessions, totalToolCalls, totalUserPrompts, mostUsedAgentSource } = metadata;
  return (
    <TileContainer>
      <ProcessOverviewTile
        title="User Prompts"
        description="Total number of user prompts"
        value={totalUserPrompts.toString()}
      />
      <ProcessOverviewTile
        title="Tool Calls"
        description="Total number of tool calls"
        value={totalToolCalls.toString()}
      />
      <ProcessOverviewTile
        title="Unique Sessions"
        description="Total number of unique agent sessions"
        value={uniqueSessions.toString()}
      />
      <ProcessOverviewTile
        title="Most Utilized Agent Source"
        description="Agent source with the highest usage"
        value={agentSourcesIcon(mostUsedAgentSource, 0)}
      />
    </TileContainer>
  );
};

const TileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
`;
